var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticClass: "reject-dialog",
      attrs: {
        width: "650px",
        title: "Attention",
        visible: _vm.rejectDialogVisible,
        scrollbar: false,
        "before-close": _vm.beforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.rejectDialogVisible = $event
        },
        closed: _vm.onClosed,
        open: _vm.onOpen,
      },
    },
    [
      _c(
        "div",
        { staticClass: "form-wrap" },
        [
          _c(
            "el-form",
            {
              ref: "rejectForm",
              staticStyle: { "padding-top": "0px", "padding-bottom": "0px" },
              attrs: {
                model: _vm.rejectForm,
                "label-position": "top",
                rules: _vm.rejectDialogRules,
              },
            },
            [
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "remark-input",
                      attrs: {
                        label: "Select Reject Reason",
                        prop: "mainRejectReason",
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "260px" },
                          attrs: { placeholder: "Please select" },
                          on: { change: _vm.mainRejectReasonChange },
                          model: {
                            value: _vm.rejectForm.mainRejectReason,
                            callback: function ($$v) {
                              _vm.$set(_vm.rejectForm, "mainRejectReason", $$v)
                            },
                            expression: "rejectForm.mainRejectReason",
                          },
                        },
                        _vm._l(
                          _vm.mainRejectReasonOptions,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.reason, value: item.reason },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "remark-input",
                      attrs: {
                        label:
                          "You will reject the meeting request, please fill in the rejection information, thank you",
                        prop: "remark",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { "text-align": "top" },
                        attrs: {
                          autosize: { minRows: 7 },
                          type: "textarea",
                          maxlength: "200",
                          "show-word-limit": "",
                          placeholder: "Please fill in the comments",
                        },
                        model: {
                          value: _vm.rejectForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.rejectForm, "remark", $$v)
                          },
                          expression: "rejectForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v(" Reject ")]
          ),
          _c(
            "el-button",
            { attrs: { plain: "" }, on: { click: _vm.onClosed } },
            [_vm._v(" Cancel ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }